import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from "../../environments/environment";
import {JWT, LocationApiKey, LocationConfig} from "../models/locationconfig";

@Injectable({
  providedIn: 'root'
})
export class MerchantService {
  constructor(private http: HttpClient) { }

  /** GET merchant from the server */
  getByMID(mid: string): Observable<LocationConfig> {
    return this.http.get<LocationConfig>(environment.baseUrl + `/api/merchants/${mid}`);
  }

  /** CREATE merchant from the server */
  create(locationConfig: LocationConfig): Observable<LocationConfig> {
    //remove JWTs before submission
    if (locationConfig?.location?.apiKeys) {
      locationConfig.location.apiKeys.forEach((apiKey: LocationApiKey) => apiKey.jwtToken = undefined);
    }
    return this.http.post<LocationConfig>(environment.baseUrl + `/api/merchants`, locationConfig);
  }

  /** UPDATE merchant from the server */
  update(locationConfig: LocationConfig): Observable<LocationConfig> {
    //remove JWTs before submission
    if (locationConfig?.location?.apiKeys) {
      locationConfig.location.apiKeys.forEach((apiKey: LocationApiKey) => apiKey.jwtToken = undefined);
    }
    return this.http.put<LocationConfig>(environment.baseUrl + `/api/merchants/${locationConfig.location.id}`, locationConfig);
  }

  /** PATCH add domain names */
  addDomainNames(mid: string, domainNames:string[]): Observable<{}> {
    return this.http.patch(environment.baseUrl + `/api/merchants/${mid}/domain-names/register`, domainNames);
  }

  /** GET merchant registered domains from the server */
  getRegisteredDomainNamesByMID(mid: string): Observable<string[]> {
    return this.http.get<string[]>(environment.baseUrl + `/api/merchants/${mid}/domain-names`);
  }

  /** GET JWT for an ApiKey from the server */
  getJWTByApiKey(mid: string, apiKeyId: string): Observable<JWT> {
    return this.http.get<JWT>(environment.baseUrl + `/api/merchants/${mid}/jwt/${apiKeyId}`);
  }
}
